exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-3834c906]{height:100vh;width:100%;display:flex;flex-direction:column;overflow:hidden}", ""]);

// exports
